"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authReducer = exports.authState = void 0;

var _immer = _interopRequireDefault(require("immer"));

var authState = {
  authUser: null
};
exports.authState = authState;

var authReducer = function authReducer(state, action) {
  var payload = action.payload;
  return (0, _immer.default)(state, function (draft) {
    switch (action.type) {
      case "ADD_AUTH_USER":
        draft.authUser = payload;
        break;

      case "REMOVE_AUTH_USER":
        draft.authUser = null;
        break;

      default:
    }
  });
};

exports.authReducer = authReducer;